import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=b790928c&"
import script from "./ActivityDetails.vue?vue&type=script&lang=js&"
export * from "./ActivityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports